import images from "./images";

const projects = [
    {
        id: 1,
        image: images.project1,
        title: "Luxury Home Build",
        details: {
            date: "March 15, 2024",
            client: "Luxury Homeowners",
            category: "Residential",
            duration: "Project timeline customized per design",
            location: "Nationwide Luxury Home Projects",
            cost: "Premium pricing based on custom requirements",
            leadArchitect: "Michael Luxington"
        },
        paragraphs: [
            "Build your dream luxury home with our expert craftsmanship and premium-quality materials. We create elegant, functional, and durable homes that reflect your unique style and vision.",
            "Our luxury home construction services cover every aspect of your project, from architectural design to high-end finishes. We focus on superior craftsmanship, innovative design, and meticulous attention to detail to ensure an extraordinary living experience."
        ],
        gallery: [
            images.project1Gallery1,
            images.project1Gallery2,
            images.project1Gallery3,
            images.project1Gallery4,
            images.project1Gallery5,
            images.project1Gallery6
        ],
        challenges: [
            "Custom Architectural Design and Engineering",
            "High-End Material Selection and Sourcing",
            "Energy-Efficient and Smart Home Integration"
        ],
        solutions: [
            "Tailored Home Design with Luxury Finishes",
            "Cutting-Edge Construction Techniques",
            "Sustainable and Eco-Friendly Building Solutions"
        ],
        results: [
            "Elegant and Timeless Architectural Design",
            "Superior Craftsmanship and Attention to Detail",
            "A Home That Combines Comfort, Beauty, and Functionality"
        ],
    },
    {
        id: 2,
        image: images.project2,
        title: "Modern Office Complex",
        details: {
            date: "April 10, 2024",
            client: "Urban Developers Inc.",
            category: "Commercial",
            duration: "12 Months",
            location: "Downtown Business District",
            cost: "Estimated at $5.2 Million",
            leadArchitect: "Sophia Kensington"
        },
        paragraphs: [
            "Experience innovation at its finest with our state-of-the-art Modern Office Complex project. Designed to offer functionality, flexibility, and contemporary aesthetics, this development caters to growing businesses and tech startups.",
            "From intelligent building systems to open-concept layouts, this office complex emphasizes productivity, sustainability, and seamless integration of smart technologies, providing a dynamic workspace for modern professionals."
        ],
        gallery: [
            images.project2Gallery1,
            images.project2Gallery2,
            images.project2Gallery3,
            images.project2Gallery4,
            images.project2Gallery5,
            images.project2Gallery6
        ],
        challenges: [
            "High-Density Urban Site Constraints",
            "Smart Building Infrastructure Integration",
            "Energy Efficiency and LEED Compliance"
        ],
        solutions: [
            "Modular Design with Scalable Floor Plans",
            "Advanced HVAC and Smart Lighting Systems",
            "Use of Recyclable and Sustainable Materials"
        ],
        results: [
            "Modern Architecture with Sleek Facade",
            "Efficient Space Utilization and Tenant Flexibility",
            "A Tech-Enabled, Eco-Conscious Work Environment"
        ],
    },
    {
        id: 3,
        image: images.project3,
        title: "Home Interior Remodeling",
        details: {
            date: "February 5, 2024",
            client: "The Morgan Family",
            category: "Renovation",
            duration: "8 Weeks",
            location: "Suburban Residential Area",
            cost: "Starting at $45,000",
            leadArchitect: "Daniel Reston"
        },
        paragraphs: [
            "Transform your living space with our expert home interior remodeling services. Whether it’s a modern kitchen upgrade, stylish living room makeover, or a complete home revamp, we bring new life to your interiors.",
            "We blend creativity with functionality, enhancing every corner of your home with custom cabinetry, updated layouts, modern finishes, and energy-efficient solutions tailored to your lifestyle."
        ],
        gallery: [
            images.project3Gallery1,
            images.project3Gallery2,
            images.project3Gallery3,
            images.project3Gallery4,
            images.project3Gallery5,
            images.project3Gallery6
        ],
        challenges: [
            "Outdated Layout and Design Flow",
            "Limited Natural Lighting in Key Areas",
            "Integration of Modern Features in Older Structures"
        ],
        solutions: [
            "Open-Concept Redesign with Functional Spaces",
            "Strategic Window Additions and Lighting Enhancements",
            "Use of Modern Materials While Retaining Home Character"
        ],
        results: [
            "A Fresh, Stylish, and Functional Interior",
            "Improved Lighting and Energy Efficiency",
            "Enhanced Comfort and Property Value"
        ],
    },
    {
        id: 4,
        image: images.project4,
        title: "Luxury Apartment Tower",
        details: {
            date: "January 20, 2024",
            client: "Skyline Developers Group",
            category: "Commercial",
            duration: "18 Months",
            location: "Downtown Metropolitan Area",
            cost: "Multi-million dollar project",
            leadArchitect: "Sophia Trent"
        },
        paragraphs: [
            "This high-rise luxury apartment tower project showcases our commitment to delivering upscale urban living. From premium finishes to smart home features, every unit is crafted to meet modern expectations of comfort and style.",
            "Our commercial construction team ensured high-performance design, energy efficiency, and superior structural integrity while accommodating urban zoning and safety requirements for multi-story developments."
        ],
        gallery: [
            images.project4Gallery1,
            images.project4Gallery2,
            images.project4Gallery3,
            images.project4Gallery4,
            images.project4Gallery5,
            images.project4Gallery6
        ],
        challenges: [
            "Urban Space Limitations and Zoning Compliance",
            "Structural Complexity for High-Rise Engineering",
            "Balancing Luxury Amenities with Energy Efficiency"
        ],
        solutions: [
            "Efficient Use of Vertical Space and Smart Layout Planning",
            "Advanced Structural Reinforcements and Materials",
            "Integration of Eco-Friendly Systems and Premium Features"
        ],
        results: [
            "A Landmark Tower with Striking Architectural Presence",
            "Modern, Luxury Apartments with Unmatched Comfort",
            "A Sustainable Asset That Enhances City Living"
        ],
    },
    {
        id: 5,
        image: images.project5,
        title: "Outdoor Patio & Landscaping",
        details: {
            date: "May 10, 2024",
            client: "The Gardenview Residence",
            category: "Renovation",
            duration: "6 Weeks",
            location: "Suburban Residential Property",
            cost: "Based on area and material preferences",
            leadArchitect: "Liam Greenway"
        },
        paragraphs: [
            "Transforming a plain backyard into a vibrant outdoor oasis, this patio and landscaping renovation combines natural beauty with functional design. The space was reimagined to create a relaxing, stylish, and low-maintenance environment for entertaining and leisure.",
            "From custom pavers and pergolas to native plantings and ambient lighting, every element was carefully chosen to reflect the client's lifestyle and enhance outdoor living. This renovation emphasizes both aesthetic appeal and sustainability."
        ],
        gallery: [
            images.project5Gallery1,
            images.project5Gallery2,
            images.project5Gallery3,
            images.project5Gallery4,
            images.project5Gallery5,
            images.project5Gallery6
        ],
        challenges: [
            "Revamping an Uneven Terrain with Limited Drainage",
            "Blending Hardscape with Softscape Elements",
            "Creating a Functional Yet Inviting Outdoor Layout"
        ],
        solutions: [
            "Grading and Drainage Correction for Landscape Stability",
            "Harmonized Design with Natural Stone and Native Plants",
            "Custom Patio Layout Featuring Dining, Seating & Garden Zones"
        ],
        results: [
            "A Stunning Outdoor Living Area for Year-Round Enjoyment",
            "Balanced Design that Merges Nature and Architecture",
            "Increased Property Value and Lifestyle Enhancement"
        ],
    },
    {
        id: 6,
        image: images.project6,
        title: "Industrial Warehouse",
        details: {
            date: "June 22, 2024",
            client: "LogiCore Industries",
            category: "Commercial",
            duration: "12 Weeks",
            location: "Logistics Zone, Industrial District",
            cost: "Competitive pricing tailored to scale and spec",
            leadArchitect: "Samantha Forge"
        },
        paragraphs: [
            "Our team successfully delivered a state-of-the-art industrial warehouse designed to optimize storage, logistics, and workflow efficiency. The facility integrates modern structural solutions with functional layouts tailored for high-volume operations.",
            "With a focus on durability, scalability, and compliance, this project includes advanced loading dock systems, energy-efficient lighting, and open-span interiors. The warehouse stands as a benchmark for future-ready industrial infrastructure."
        ],
        gallery: [
            images.project6Gallery1,
            images.project6Gallery2,
            images.project6Gallery3,
            images.project6Gallery4,
            images.project6Gallery5,
            images.project6Gallery6
        ],
        challenges: [
            "Meeting Complex Zoning and Permitting Requirements",
            "Designing for Heavy-Duty Equipment and Logistics Flow",
            "Integrating Sustainable Building Practices"
        ],
        solutions: [
            "Collaborative Planning with Local Authorities",
            "Reinforced Flooring and High-Clearance Design",
            "Use of Eco-Friendly Materials and LED Systems"
        ],
        results: [
            "Robust and Scalable Warehouse Infrastructure",
            "Streamlined Logistics and Operational Efficiency",
            "Low-Maintenance and Long-Term Cost Savings"
        ],
    }

];

export default projects;